<template>
  <div class="columns is-centered">
    <section class="section">
      <div class="box">
        <div class="pricing-table">
          <div class="pricing-plan is-danger">
            <div class="plan-header">MileLogix</div>
            <div class="plan-header">30 Day Trial</div>

            <div class="plan-price">
              <span class="plan-price-amount">
                <span class="plan-price-currency"></span>Free!
              </span>
            </div>
            <div class="plan-items">
              <div class="plan-item">Calendar based mileage tracking</div>
              <div class="plan-item">
                Blazing
                <i>fast</i> report generation
              </div>
              <div class="plan-item">HIPAA Compliant</div>
              <div class="plan-item">Supports any exported calendar file</div>
              <div class="plan-item">No credit card required</div>
            </div>
            <div class="plan-footer">
              <button class="button is-medium" @click="welcomeTrialUser()">Choose</button>
            </div>
          </div>
          <div class="pricing-plan is-active">
            <div class="plan-header">MileLogix</div>
            <div class="plan-header">Annual Plan</div>

            <div class="plan-price">
              <span class="plan-price-amount">
                <span class="plan-price-currency">$</span>5
              </span>/month/user
            </div>
            <div class="plan-items">
              <div class="plan-item">Calendar based mileage tracking</div>
              <div class="plan-item">
                Blazing
                <i>fast</i> report generation
              </div>
              <div class="plan-item">HIPAA Compliant</div>
              <div class="plan-item">Supports any exported calendar file</div>
              <div class="plan-item">No cancellation fees</div>
            </div>
            <div class="plan-footer">
              <button class="button is-medium" @click="checkout('annual')">Choose</button>
            </div>
          </div>
          <div class="pricing-plan is-link">
            <div class="plan-header">MileLogix</div>
            <div class="plan-header">Monthly Plan</div>

            <div class="plan-price">
              <span class="plan-price-amount">
                <span class="plan-price-currency">$</span>8
              </span>/month/user
            </div>
            <div class="plan-items">
              <div class="plan-item">Calendar based mileage tracking</div>
              <div class="plan-item">
                Blazing
                <i>fast</i> report generation
              </div>
              <div class="plan-item">HIPAA Compliant</div>
              <div class="plan-item">Supports any exported calendar file</div>
              <div class="plan-item">No cancellation fees</div>
            </div>
            <div class="plan-footer">
              <button class="button is-medium" @click="checkout('monthly')">Choose</button>
            </div>
          </div>
        </div>
        <p class="help is-danger" v-if="error.payment">Error processing payment. Please try again.</p>
      </div>
      <div>
        <vue-stripe-checkout
          ref="checkoutRef"
          :name="name"
          :description="description"
          :currency="currency"
          :amount="amount"
          :allow-remember-me="false"
          :zip-code="true"
          :email="email"
          @done="done"
          @opened="opened"
          @closed="closed"
          @canceled="canceled"
        ></vue-stripe-checkout>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import VueStripeCheckout from "vue-stripe-checkout";
import { setTimeout } from "timers";

Vue.use(VueStripeCheckout, process.env.VUE_APP_STRIPE_PUB_KEY);

export default {
  props: {
    companyRecord: {
      type: String,
      default: "",
      required: true
    },

    userRecord: {
      type: String,
      default: "",
      required: true
    }
  },
  data() {
    return {
      name: "ABALogix LLC",
      description: undefined,
      currency: "usd",
      amount: undefined,
      email: undefined,
      subscriptionType: undefined,
      error: {
        payment: false
      }
    };
  },
  methods: {
    checkout(subscriptionType) {
      switch (subscriptionType) {
        case "annual":
          this.subscriptionType = subscriptionType;
          this.amount = 500 * 12; //Set for Stripe Checkout display purposes *only*
          this.description = "Annual MileLogix Subscription";
          break;

        case "monthly":
          this.subscriptionType = subscriptionType;
          this.amount = 800; //Set for Stripe Checkout display purposes *only*
          this.description = "Monthly MileLogix Subscription";
          break;
      }
      setTimeout(() => this.$refs.checkoutRef.open());
    },

    welcomeTrialUser() {
      let trialUserData = {
        user_record_id: this.userRecord
      };

      this.$http
        .post(process.env.VUE_APP_API_URL + "/welcome", trialUserData)
        .then(() => this.$router.push("/"))
        .catch(this.$router.push("/"));
    },
    done({ token }) {
      let stripeTransactionData = {
        token_id: token.id,
        subscription_type: this.subscriptionType,
        user_record_id: this.userRecord,
        company_record_id: this.companyRecord
      };
      this.$http
        .post(process.env.VUE_APP_API_URL + "/payment", stripeTransactionData)
        .then(this.$router.push("/"))
        .catch(function() {
          this.error.payment = true;
        });
    },
    opened() {},
    closed() {},
    canceled() {}
  }
};
</script>

<style lang="sass" scoped>
@import "bulma/bulma.sass"
@import "bulma-pricingtable/dist/css/bulma-pricingtable.sass"
</style>
